module.exports = "<div ngxUiLoaderBlurred>\r\n  <!--<div class=\"row\">\r\n     <div class=\"col-lg-12 col-md-12 book-appointment-h1 text-center\">\r\n          <h1>Book Appointment</h1>\r\n     </div>\r\n   </div>-->\r\n  <!--<div class='row'>\r\n     <div class='col-sm-3'>\r\n      <app-nav-menu></app-nav-menu>\r\n    </div>\r\n    <div class='col-sm-12 body-content'>\r\n\r\n    </div>\r\n  </div>-->\r\n  <router-outlet></router-outlet>\r\n</div>\r\n<ngx-ui-loader></ngx-ui-loader>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main